import { render, staticRenderFns } from "./DeliverySummary.vue?vue&type=template&id=c6907142&scoped=true&"
import script from "./DeliverySummary.vue?vue&type=script&lang=js&"
export * from "./DeliverySummary.vue?vue&type=script&lang=js&"
import style0 from "./DeliverySummary.vue?vue&type=style&index=0&id=c6907142&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6907142",
  null
  
)

export default component.exports